/*eslint-disable*/
import api from '..';

export default class punctuationMarksGameItemsApi {
    // GET: items
    static get() {
        return api.axios.get('/punctuation-marks').then(({ data }) => data.data);
    }

    //POST: text
    static store(params) {
        return api.axios.post('/punctuation-marks', params);
    }

    static update(id, params) {
        return api.axios.post(`/punctuation-marks/${id}`, params);
    }

    static delete(id) {
        return api.axios.delete(`/punctuation-marks/${id}`);
    }
}
